import { Typography } from '@mui/material'

const HelpText = () => (
  <div className='p-5'>
    <Typography variant='h4'>Reports & statistics</Typography>
    <p>Reports open on Pass Activity. Use the report menu to change chart, the period selector to change the reporting range, and the template selector to focus the chart on one template.</p>
    <Typography variant='h5'>Template selection</Typography>
    <p>Charts with a template selector start with the current template. Choosing a different template makes it the current template for the rest of Studio. Choose All templates when you need an account-wide view.</p>
    <Typography variant='h5'>Available reports</Typography>
    <ul>
      <li><strong>Pass Activity:</strong> issued, updated and notified passes.</li>
      <li><strong>Adoption and Installs:</strong> Apple and Google installation activity.</li>
      <li><strong>Template Changes, Scans and Pass Types:</strong> design activity, scan behaviour and pass-type distribution.</li>
      <li><strong>Install Report:</strong> generates a downloadable pass-install export for one template.</li>
      <li><strong>Managed Pass Data:</strong> exports data relevant to managed pass programmes.</li>
    </ul>
  </div>
)

export default HelpText
